import { atomWithQuery } from 'jotai-tanstack-query';
import { fakerKO as faker } from '@faker-js/faker';
import { format } from 'date-fns';

import type { UserData } from '@/@types/admin';

export const usersAtom = atomWithQuery<UserData[]>(() => ({
  queryKey: ['USERS'],
  queryFn: async () => {
    const data = await getUsers();
    return data;
  },
  refetchOnMount: false,
}));

async function getUsers() {
  // TODO: Get data from API
  await new Promise((resolve) => setTimeout(resolve, 1000));
  const sampleData = Array(86)
    .fill(null)
    .map((_, i) => {
      const birthday = faker.date.birthdate({ mode: 'age', min: 20, max: 65 });
      const registerDate = faker.date.recent({ days: 30 });
      const editDate = faker.date.between({ from: registerDate, to: new Date() });

      return {
        status: faker.helpers.arrayElement(['활동', '정지']),
        id: i.toString(),
        email: faker.internet.email(),
        name: faker.person.fullName(),
        tel: faker.helpers.fromRegExp('010-[0-9]{4}-[0-9]{4}'),
        birthday: format(birthday, 'yyyy-MM-dd'),
        registerDate: format(registerDate, 'yyyy-MM-dd'),
        editDate: format(editDate, 'yyyy-MM-dd'),
      };
    });

  return sampleData;
}
